import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import Ticketassign from "../components/Chat&assign/Ticketassign";
import Menu from "../components/Menu/Menu";
import Marquee from "react-fast-marquee";
import { FaRegUserCircle, FaInfoCircle, FaSearchengin } from "react-icons/fa";
import Chatbox from "../components/Chat&assign/Chatbox";
import { toast } from "react-toastify";
import NoUsers from "../components/Dashboard/NoUsers";
import useuserstore from "../store/useuserstore";
import NoTickets from "../components/Dashboard/NoTickets";
import { useClientList } from "../hooks/useClientList";
import { formatDateTime } from "../utils/dateutils";

function Ticketdashboard() {
  const [tickets, setTickets] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showRemarksPopup, setShowRemarksPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [Remarks, setRemarks] = useState("");
  const [currentTicketId, setCurrentTicketId] = useState(null);

  const rowsPerPage = 10;
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(true);
  const [currentPageOpened, setCurrentPageOpened] = useState(1);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const [ticketNumber, setTicketNumber] = useState("");

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  // Separate open and closed tickets
  const openedTickets = tickets.filter(
    (ticket) => ticket.status !== "Closed" && ticket.status !== "Dismissed"
  );
  const closedTickets = tickets.filter(
    (ticket) => ticket.status === "Closed" || ticket.status === "Dismissed"
  );

  // Role-based filter for opened tickets
  const filteredOpenedTickets = openedTickets.filter((openedTickets) => {
    return userDetails.role === "cmanager"
      ? openedTickets.client_id?.toString() === userDetails.clientid?.toString()
      : true;
  });

  const totalPagesOpened = Math.ceil(
    filteredOpenedTickets.length / rowsPerPage
  );
  const startIndexOpened = (currentPageOpened - 1) * rowsPerPage;
  const currentRowsOpened = filteredOpenedTickets.slice(
    startIndexOpened,
    startIndexOpened + rowsPerPage
  );

  // Role-based filter for closed tickets
  const filteredClosedTickets = closedTickets.filter((closedTickets) => {
    return userDetails.role === "cmanager"
      ? closedTickets.client_id?.toString() === userDetails.clientid?.toString()
      : true;
  });

  const totalPagesClosed = Math.ceil(
    filteredClosedTickets.length / rowsPerPage
  );
  const startIndexClosed = (currentPageClosed - 1) * rowsPerPage;
  const currentRowsClosed = filteredClosedTickets.slice(
    startIndexClosed,
    startIndexClosed + rowsPerPage
  );

  const { clientlist } = useClientList(userDetails);

  // Find the client object matching the logged-in clientid
  const selectedClient = (clientlist || []).find(
    (client) => Number(client.id) === Number(userDetails?.clientid)
  );

  // Determine if the logged-in user should see the approval column
  const showApprovalColumn =
    selectedClient &&
    ["cmanager", "bh"].includes(userDetails?.role) &&
    ((userDetails?.role === "cmanager" &&
      selectedClient.tic_approval?.approval_cmanager === true) ||
      (userDetails?.role === "bh" &&
        selectedClient.tic_approval?.approval_bh === true));

  const handleSearch = () => {
    const foundTicket = tickets.find(
      (t) => String(t.ticketnumber) === String(ticketNumber.trim())
    );

    if (foundTicket) {
      const ticketData = {
        userId: foundTicket.user_id,
        ticketId: foundTicket.id,
        ticketNumber: foundTicket.ticketnumber,
        employeeName: foundTicket.name,
        clientEmail: foundTicket.email,
        ph: foundTicket.ph,
        title: foundTicket.e_title,
        errorDescription: foundTicket.e_des,
        file: foundTicket.files,
        status: foundTicket.status,
        asname: foundTicket.asname,
        closedby_name: foundTicket.clsname,
        create: foundTicket.create,
        res_time: foundTicket.res_time,
        closed_time: foundTicket.ctime,
      };

      handleViewClick(ticketData);
    } else {
      alert("Ticket not found!");
    }
  };

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setIsModalOpen(true);

    if (row.status === "Assigned" && row.asname === userDetails?.username) {
      handlestatusopen(row.ticketId);
    }
  };

  const handlestatusopen = async (ticketId) => {
    if (!ticketId) {
      toast.error("No ticket selected.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", ticketId);

      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/statusopen.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Ticket status has been updated to Opened");
        fetchTickets(); // refresh ticket list
      } else {
        toast.error(data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
    setTicketNumber("");
    // setMessages([]);
  };

  const fetchTickets = async () => {
    try {
      const formData = new FormData();
      formData.append("sub", userDetails?.sub);
      formData.append("client_id", userDetails?.clientid);
      formData.append("dept", userDetails?.dept);

      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/gettickets.php`;
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result.message === "Records fetched successfully") {
        setTickets(result.data);
      } else {
        console.log("No tickets found or unexpected response:", result);
      }
    } catch (error) {
      console.log("Error fetching tickets:", error);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  // const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // const fetchMessages = async (ticketNumber) => {
  //   try {
  //     const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/getmsg.php`;
  //     const formData = new FormData();
  //     formData.append("ticket_number", ticketNumber);

  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     const data = await response.json();

  //     if (response.ok && data.message === "Records fetched successfully") {
  //       setMessages(data.data);
  //     } else {
  //       setMessages([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching messages:", error);
  //     setMessages([]);
  //   }
  // };

  const handlereopen = async (ticketId) => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/reopen.php`;
      const formData = new FormData();
      formData.append("id", ticketId);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok && data.message === "Ticket reopened successfully") {
        toast.success("Ticket reopened successfully");
        fetchTickets();
      } else {
        toast.error("Failed to reopen ticket");
      }
    } catch (error) {
      toast.error("Error on reopening ticket");
    }
  };

  // const [searchedTicket, setSearchedTicket] = useState("");
  // const [chatMessages, setChatMessages] = useState([]);

  const handlestatus = async (status, ID) => {
    const ticketId = ID;
    if (!ticketId) {
      toast.error("No ticket selected.");
      return;
    }
    // if ((!selectedRow || !selectedRow.ticketId) && !ID) {
    //   toast.error("No ticket selected.");
    //   return;
    // }

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/status.php`;
      const formData = new FormData();
      formData.append("id", ticketId);
      formData.append("status", status);
      formData.append("clsid", userDetails.id);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(`Ticket status has been updated to ${status}`);
        fetchTickets(); // refresh list
        closeModal(); // close modal
      } else {
        toast.error(data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  const handleappprovalstatus = async (status, ID) => {
    if (!ID) {
      toast.error("No ticket selected.");
      return;
    }

    const Approval = userDetails?.role === "bh" ? "A2" : "A1";
    const DateAndTime = formatDateTime(new Date());

    try {
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/approval_actions.php`;
      const formData = new FormData();
      formData.append("id", ID);
      formData.append("Approval", Approval);
      formData.append("status", status);
      formData.append("remarks", Remarks);
      formData.append("DateAndTime", DateAndTime);
      formData.append("actionbyid", userDetails.id);

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(`Ticket status has been updated to ${status}`);
        fetchTickets();
      } else {
        toast.error(data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  const Tuser = useuserstore((state) => state.Tuser);

  const boxRef1 = useRef(null);
  const boxRef2 = useRef(null);

  // Function to scroll to a specific box (you can pass a ref to scroll to different boxes)
  const scrollToBox = (targetRef) => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div>
      {/* menu box */}
      <div>
        <h1 className="h1">
          {userDetails.role === "admin"
            ? "Admin Portal"
            : userDetails.role === "imanager"
            ? "Support Manager Portal"
            : userDetails.role === "icoordinator"
            ? "Support Co-ordinator Portal"
            : userDetails.role === "cmanager"
            ? "Manager Dashboard"
            : ""}
        </h1>
      </div>
      <div className="center">
        {/* <div>{userDetails?.role === "cmanager" && <h1>{userDetails.clientname}</h1>}</div> */}
        <div className="menu-position">
          <h2 className="clientname">
            {userDetails?.role === "cmanager" ||
            userDetails?.role === "user" ||
            userDetails?.role === "bh"
              ? userDetails?.clientname
              : userDetails.companyname}
          </h2>
          <div className="welcome_tag">
            <span>
              <div className="marquee-container">
                <Marquee
                  speed={40}
                  direction="right"
                  pauseOnHover
                  gradient={false}
                >
                  {userDetails.username}
                </Marquee>
              </div>
            </span>
            <div className="profile_icon">
              <FaRegUserCircle />
            </div>
          </div>
        </div>
      </div>

      <div className="flex">
        <Menu fetchTickets={fetchTickets} tickets={tickets.length} />
        <div className="parent-container1">
          <h2 className="retick">Track by Ticket Id...</h2>
          <div className="search-container">
            <input
              type="text"
              placeholder="Search by Ticket Number"
              value={ticketNumber}
              onChange={(e) => setTicketNumber(e.target.value)}
            />
            <button className="sebtn" onClick={handleSearch}>
              <FaSearchengin />
            </button>
          </div>
        </div>
      </div>

      {Tuser === 1 ? (
        <NoUsers />
      ) : tickets.length === 0 ? (
        <NoTickets />
      ) : (
        <>
          {/* tickets cards */}
          <div className="ticket-summary">
            <div className="ticket-card">
              <span className="ki">Total Tickets:</span>
              <span className="ki">
                {
                  tickets.filter((ticket) =>
                    userDetails.role === "cmanager"
                      ? ticket.client_id?.toString() ===
                        userDetails.clientid?.toString()
                      : true
                  ).length
                }
              </span>
            </div>
            <div className="ticket-card">
              <span className="ki">Pending Approvals Tickets:</span>
              <span className="ki">
                {
                  tickets.filter(
                    (ticket) =>
                      ticket.status === "Approval Pending" &&
                      (userDetails.role === "cmanager"
                        ? ticket.client_id?.toString() ===
                          userDetails.clientid?.toString()
                        : true) // show all if not cmanager
                  ).length
                }
              </span>
            </div>
            <div className="ticket-card">
              <span className="ki">UnAssigned Tickets:</span>
              <span className="ki">
                {
                  tickets.filter(
                    (ticket) =>
                      ticket.status === "Un Assigned" &&
                      (userDetails.role === "cmanager"
                        ? ticket.client_id?.toString() ===
                          userDetails.clientid?.toString()
                        : true) // show all if not cmanager
                  ).length
                }
              </span>
            </div>
            <div className="ticket-card">
              <span className="ki">Assigned Tickets:</span>
              <span className="ki">
                {
                  tickets.filter(
                    (ticket) =>
                      ticket.status === "Assigned" &&
                      (userDetails.role === "cmanager"
                        ? ticket.client_id?.toString() ===
                          userDetails.clientid?.toString()
                        : true)
                  ).length
                }
              </span>
            </div>
            <div className="ticket-card">
              <span className="ki">Opened Tickets:</span>
              <span className="ki">
                {
                  tickets.filter(
                    (ticket) =>
                      ticket.status === "Opened" &&
                      (userDetails.role === "cmanager"
                        ? ticket.client_id?.toString() ===
                          userDetails.clientid?.toString()
                        : true)
                  ).length
                }
              </span>
            </div>
            <div className="ticket-card">
              <span className="ki">Hold Tickets:</span>
              <span className="ki">
                {
                  tickets.filter(
                    (ticket) =>
                      ticket.status === "Hold" &&
                      (userDetails.role === "cmanager"
                        ? ticket.client_id?.toString() ===
                          userDetails.clientid?.toString()
                        : true)
                  ).length
                }
              </span>
            </div>
            <div className="ticket-card">
              <span className="ki">Closed Tickets:</span>
              <span className="ki">
                {
                  closedTickets.filter(
                    (ticket) =>
                      ticket.status === "Closed" &&
                      (userDetails.role === "cmanager"
                        ? ticket.client_id?.toString() ===
                          userDetails.clientid?.toString()
                        : true)
                  ).length
                }
              </span>
            </div>
            <div className="ticket-card">
              <span className="ki">Dismissed Tickets:</span>
              <span className="ki">
                {
                  closedTickets.filter(
                    (ticket) =>
                      ticket.status === "Dismissed" &&
                      (userDetails.role === "cmanager"
                        ? ticket.client_id?.toString() ===
                          userDetails.clientid?.toString()
                        : true)
                  ).length
                }
              </span>
            </div>
          </div>

          {/* opened  */}
          <div style={{ zIndex: 1000 }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={() => {
                  setIsOpen1(!isOpen1);
                  setIsOpen(false);
                }}
                style={{
                  background: "grey",
                  padding: "8px 16px",
                  borderRadius: "5px",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                PENDING TICKETS
              </button>
            </div>

            <motion.div
              initial={{ height: "auto", opacity: 1 }}
              animate={{
                height: isOpen1 ? "auto" : 0,
                opacity: isOpen1 ? 1 : 0,
              }}
              transition={{ duration: 0.5 }}
              style={{
                overflow: "hidden",
                padding: isOpen1 ? "10px" : "0px",
                borderRadius: "5px",
                marginTop: "10px",
              }}
            >
              <div className="tda">
                <div className="tdb">
                  <div className="scroll">
                    <div className="tdc">
                      <table border="1" className="tdd">
                        <thead className="tde">
                          <tr>
                            <th className="tdf">Serial No</th>
                            {["admin", "imanager", "icoordinator"].includes(
                              userDetails?.role
                            ) && <th className="tdf">Client Name</th>}
                            <th className="tdf">Employee Name</th>
                            <th className="tdf">Ticket Number</th>
                            <th className="tdf">Error Tittle</th>
                            <th className="tdf">Full Details</th>
                            <th className="tdf">Status</th>
                            {["cmanager", "bh"].includes(userDetails?.role) &&
                              showApprovalColumn && (
                                <th className="tdf">Approval 1</th>
                              )}
                            {["bh"].includes(userDetails?.role) &&
                              showApprovalColumn && (
                                <th className="tdf">Approval 2</th>
                              )}
                            {["admin", "imanager", "icoordinator"].includes(
                              userDetails?.role
                            ) && (
                              <>
                                <th>Assigned Name</th>
                                <th>Assign</th>
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody className="tdg">
                          {currentRowsOpened.length > 0 ? (
                            currentRowsOpened.map((ticket, index) => (
                              <tr key={ticket.id}>
                                <td className="tdh">
                                  {startIndexOpened + index + 1}.
                                </td>
                                {["admin", "imanager", "icoordinator"].includes(
                                  userDetails?.role
                                ) && (
                                  <td className="tdh">{ticket.client_code}</td>
                                )}
                                <td className="tdh">{ticket.name}</td>
                                <td className="tdh">{ticket.ticketnumber}</td>
                                <td className="tdh">{ticket.e_title}</td>
                                <td className="tdh">
                                  <button
                                    className="tdi"
                                    onClick={() =>
                                      handleViewClick({
                                        ticketNumber: ticket.ticketnumber,
                                        create: ticket.create,
                                        employeeName: ticket.name,
                                        clientEmail: ticket.email,
                                        ph: ticket.ph,
                                        errorDescription: ticket.e_des,
                                        file: ticket.files,
                                        title: ticket.e_title,
                                        ticketId: ticket.id,
                                        status: ticket.status,
                                        res_time: ticket.res_time,
                                        asname: ticket.asname,
                                        remarks: ticket.remarks,
                                        approval1Time:
                                          ticket?.approved_by?.A1?.DateAndTime,
                                        approval2Time:
                                          ticket?.approved_by?.A2?.DateAndTime,
                                        a1name:
                                          ticket?.approved_by?.A1?.actionbyid ||
                                          "",
                                        a2name:
                                          ticket?.approved_by?.A2?.actionbyid ||
                                          "",
                                        a1status:
                                          ticket?.approved_by?.A1?.status || "",
                                        a2status:
                                          ticket?.approved_by?.A2?.status || "",
                                        unassignedTime: ticket.unassignedTime,
                                      })
                                    }
                                  >
                                    View
                                  </button>
                                </td>
                                <td className="tdh">{ticket.status}</td>

                                {["admin", "imanager", "icoordinator"].includes(
                                  userDetails?.role
                                ) && <td className="tdh">{ticket.asname}</td>}

                                {["admin", "imanager", "icoordinator"].includes(
                                  userDetails?.role
                                ) && (
                                  <td className="tdh">
                                    {ticket.status !== "Approval Pending" && (
                                      <Ticketassign
                                        TicketNumber={ticket.id}
                                        fetchTickets={fetchTickets}
                                        Ticketstore={setTickets}
                                        assignedTo={ticket?.asid}
                                        selectedticketno={ticket.ticketnumber}
                                      />
                                    )}
                                  </td>
                                )}

                                {["cmanager", "bh"].includes(
                                  userDetails?.role
                                ) &&
                                  showApprovalColumn && (
                                    <td className="tdf-btn">
                                      {ticket?.approved_by?.A1 ? (
                                        <>
                                          {ticket.approved_by.A1.status} by{" "}
                                          {ticket.approved_by.A1.actionbyid}
                                          <span
                                            style={{
                                              marginLeft: "8px",
                                              color: "#666",
                                              textWrap: "nowrap",
                                              fontSize: "13px",
                                            }}
                                          >
                                            {ticket.approved_by.A1.DateAndTime}
                                          </span>
                                        </>
                                      ) : userDetails?.role === "bh" ? (
                                        ticket?.status !== "Un Assigned" ? (
                                          `${ticket?.approvalpending1}'s approval is Pending`
                                        ) : (
                                          "Business Head is Approved this Ticket"
                                        )
                                      ) : ticket.status ===
                                        "Approval Pending" ? (
                                        <button
                                          className="btn-remarks"
                                          onClick={() => {
                                            setCurrentTicketId(ticket.id);
                                            setShowRemarksPopup(true);
                                          }}
                                        >
                                          Actions
                                        </button>
                                      ) : null}
                                    </td>
                                  )}

                                {["bh"].includes(userDetails?.role) &&
                                  showApprovalColumn && (
                                    <td className="tdf-btn">
                                      <>
                                        {ticket?.approved_by?.A2 ? (
                                          <>
                                            {ticket?.approved_by?.A2?.status} by{" "}
                                            {
                                              ticket?.approved_by?.A2
                                                ?.actionbyid
                                            }
                                            <span
                                              style={{
                                                marginLeft: "8px",
                                                color: "#666",
                                                fontSize: "13px",
                                                textWrap: "nowrap",
                                              }}
                                            >
                                              {
                                                ticket.approved_by.A2
                                                  .DateAndTime
                                              }
                                            </span>
                                          </>
                                        ) : (
                                          ticket.status ===
                                            "Approval Pending" && (
                                            <button
                                              className="btn-remarks"
                                              onClick={() => {
                                                setCurrentTicketId(ticket.id);
                                                setShowRemarksPopup(true);
                                              }}
                                            >
                                              Actions
                                            </button>
                                          )
                                        )}
                                      </>
                                    </td>
                                  )}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9" className="tdh">
                                No tickets available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {showRemarksPopup && (
                  <div className="remarks-overlay">
                    <div className="remarks-popup">
                      <button
                        className="remarks-close"
                        onClick={() => setShowRemarksPopup(false)}
                      >
                        ✕
                      </button>
                      <h3>Enter Remarks</h3>

                      <textarea
                        className="remarks-input"
                        placeholder="Type your remarks here..."
                        value={Remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />

                      <div className="remarks-buttons">
                        <button
                          className="btn-submit"
                          onClick={() => {
                            handleappprovalstatus(
                              "Approved",
                              currentTicketId,
                              Remarks
                            );
                            setShowRemarksPopup(false);
                            setRemarks("");
                          }}
                        >
                          Approval
                        </button>

                        <button
                          className="btn-cancel"
                          onClick={() => {
                            handleappprovalstatus(
                              "Dismissed",
                              currentTicketId,
                              Remarks
                            );
                            setShowRemarksPopup(false);
                            setRemarks("");
                          }}
                        >
                          Dismiss
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {totalPagesOpened > 1 && (
                  <div className="tdj">
                    <div>
                      <h2 className="tdk">
                        Page {currentPageOpened} of {totalPagesOpened}
                      </h2>

                      <div className="tdl">
                        {currentPageOpened !== 1 && (
                          <>
                            <button
                              className="tdm"
                              onClick={() => setCurrentPageOpened(1)}
                            >
                              &laquo; First page
                            </button>

                            <button
                              className="tdm"
                              onClick={() =>
                                setCurrentPageOpened((prev) =>
                                  Math.max(prev - 1, 1)
                                )
                              }
                            >
                              &lt; Previous
                            </button>
                          </>
                        )}

                        {currentPageOpened !== totalPagesOpened && (
                          <>
                            <button
                              className="tdn"
                              onClick={() =>
                                setCurrentPageOpened((prev) =>
                                  Math.min(prev + 1, totalPagesOpened)
                                )
                              }
                            >
                              Next &gt;
                            </button>

                            <button
                              className="tdo"
                              onClick={() =>
                                setCurrentPageOpened(totalPagesOpened)
                              }
                            >
                              Last page &raquo;
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {isModalOpen && selectedRow && (
                  <div className="tdp">
                    <div className="tdr">
                      <div className="tds-container">
                        <div className="tds" ref={boxRef1}>
                          <h2 className="tdt">Ticket Details</h2>
                          <div className="tinfo-container">
                            <div className="tinfo-ticket-wrapper">
                              <p className="tinfo-ticket-number">
                                <strong>{selectedRow.ticketNumber}</strong>
                                <span className="tinfo-icon-wrapper">
                                  <FaInfoCircle className="tinfo-icon" />
                                  <span className="tinfo-tooltip">
                                    Ticket Created: {selectedRow.create} <br />
                                    {selectedRow.approval1Time && (
                                      <>
                                        Manager Approved Time:{" "}
                                        {selectedRow.a1name} -{" "}
                                        {selectedRow.approval1Time}
                                        <br />
                                      </>
                                    )}
                                    {selectedRow.approval2Time && (
                                      <>
                                        Business Head Approved Time:{" "}
                                        {selectedRow.a2name} -{" "}
                                        {selectedRow.approval2Time}
                                        <br />
                                      </>
                                    )}
                                    {selectedRow.unassignedTime && (
                                      <>
                                        Ticket Landed Time:{" "}
                                        {selectedRow.unassignedTime}
                                        <br />
                                      </>
                                    )}
                                    {["Hold", "Opened"].includes(
                                      selectedRow?.status
                                    ) &&
                                      `Ticket Opened: ${
                                        selectedRow.res_time ===
                                          "0000-00-00 00:00:00" ||
                                        !selectedRow.res_time
                                          ? "-"
                                          : selectedRow.res_time
                                      }`}
                                  </span>
                                </span>
                              </p>
                            </div>

                            {/* Employee info row */}
                            <div className="tinfo-employee-row">
                              <p className="tinfo-field">
                                <strong className="tinfo-label">
                                  Employee Name:
                                </strong>
                                <br />
                                {selectedRow.employeeName}
                              </p>
                              <p className="tinfo-field">
                                <strong className="tinfo-label">
                                  Employee Email:
                                </strong>
                                <br />
                                {selectedRow.clientEmail}
                              </p>
                              <p className="tinfo-field">
                                <strong className="tinfo-label">
                                  Contact Number:
                                </strong>
                                <br />
                                {selectedRow.ph}
                              </p>
                            </div>

                            <div className="tinfo-employee-row">
                              <p className="tinfo-field">
                                <strong className="tinfo-label">
                                  Error Title:
                                </strong>
                                <br />
                                {selectedRow.title}
                              </p>
                              {/* <pre>{JSON.stringify(selectedRow.remarks, null, 2)}</pre> */}

                              {/* Properly map remarks to display */}
                              {selectedRow.remarks &&
                                typeof selectedRow.remarks === "object" &&
                                Object.entries(selectedRow.remarks).map(
                                  ([key, value]) => {
                                    let label =
                                      key === "A1" ? (
                                        <>
                                          Manager Remarks ({selectedRow?.a1name}
                                          ) - {selectedRow?.a1status}
                                        </>
                                      ) : key === "A2" ? (
                                        <>
                                          Business Head Remarks (
                                          {selectedRow?.a2name}) -{" "}
                                          {selectedRow?.a2status}
                                        </>
                                      ) : (
                                        key
                                      );
                                    return (
                                      <p key={key} className="tinfo-field">
                                        <strong className="tinfo-label">
                                          {label}:
                                        </strong>{" "}
                                        {value}
                                      </p>
                                    );
                                  }
                                )}
                            </div>

                            <p className="tinfo-field">
                              <strong className="tinfo-label">
                                Error Description:
                              </strong>
                              <br />
                              {selectedRow.errorDescription}
                            </p>

                            {selectedRow.file && (
                              <p className="tinfo-field">
                                <strong className="tinfo-label">File:</strong>
                                <br />
                                <a
                                  href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="tinfo-file-link"
                                >
                                  {selectedRow.file}
                                </a>
                              </p>
                            )}
                          </div>
                        </div>

                        {selectedRow?.status !== "Approval Pending" && (
                          <div className="chatbox-wrapper">
                            <Chatbox
                              selectedRowID={selectedRow.ticketId} // OR searchedTicketId="TIC-2025-00123"
                              selectedEmail={selectedRow.clientEmail}
                              status={selectedRow.status}
                              ticketclosed={selectedRow.closed_time}
                              ticketassign={selectedRow.asname}
                            />

                            <div className="btn-container">
                              <button
                                className="ticket-details-btn"
                                onClick={() => scrollToBox(boxRef1)}
                              >
                                Ticket Details
                              </button>
                              {userDetails?.role !== "cmanager" &&
                                userDetails?.role !== "user" &&
                                userDetails?.role !== "bh" && (
                                  <div className="tdx">
                                    {selectedRow?.status === "Hold" ? (
                                      <button
                                        className="tdz"
                                        onClick={() =>
                                          handlestatus(
                                            "Closed",
                                            selectedRow?.ticketId
                                          )
                                        }
                                      >
                                        Closed
                                      </button>
                                    ) : (
                                      <>
                                        <button
                                          className="tdy"
                                          onClick={() =>
                                            handlestatus(
                                              "Hold",
                                              selectedRow?.ticketId
                                            )
                                          }
                                        >
                                          Hold
                                        </button>
                                        <button
                                          className="tdz"
                                          onClick={() =>
                                            handlestatus(
                                              "Closed",
                                              selectedRow?.ticketId
                                            )
                                          }
                                        >
                                          Closed
                                        </button>
                                      </>
                                    )}
                                  </div>
                                )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="tdq" onClick={closeModal}>
                        &times;
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          </div>

          {/* closed  */}
          <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={() => {
                  setIsOpen(!isOpen);
                  setIsOpen1(false);
                }}
                style={{
                  background: "grey",
                  padding: "8px 16px",
                  borderRadius: "5px",
                  color: "white",
                  cursor: "pointer",
                }}
                // className="closed"
              >
                CLOSED TICKETS
              </button>
            </div>

            <motion.div
              initial={{ height: "auto", opacity: 1 }}
              animate={{
                height: isOpen ? "auto" : 0,
                opacity: isOpen ? 1 : 0,
              }}
              transition={{ duration: 0.5 }}
              style={{
                overflow: "hidden",
                padding: isOpen ? "10px" : "0px",
                borderRadius: "5px",
                marginTop: "10px",
              }}
            >
              <div className="outer">
                <div className="scroll">
                  <div className="tdc">
                    <table border="1" className="tdd">
                      <thead className="tde">
                        <tr>
                          <th className="tdf">Serial No</th>
                          {["admin", "imanager", "icoordinator"].includes(
                            userDetails?.role
                          ) && <th className="tdf">Client Name</th>}
                          <th className="tdf">Employee Name</th>
                          <th className="tdf">Ticket Number</th>
                          <th className="tdf">Error Tittle</th>
                          <th className="tdf">Full Details</th>
                          <th className="tdf">Status</th>
                          {["admin", "imanager", "icoordinator"].includes(
                            userDetails?.role
                          ) && <th className="tdf">Action</th>}
                        </tr>
                      </thead>
                      <tbody className="tdg">
                        {currentRowsClosed.length > 0 ? (
                          currentRowsClosed.map((ticket, index) => (
                            <tr key={ticket.id}>
                              <td className="tdh">
                                {startIndexClosed + index + 1}.
                              </td>
                              {["admin", "imanager", "icoordinator"].includes(
                                userDetails?.role
                              ) && (
                                <td className="tdh">{ticket.client_code}</td>
                              )}
                              <td className="tdh">{ticket.name}</td>
                              <td className="tdh">{ticket.ticketnumber}</td>
                              <td className="tdh">{ticket.e_title}</td>

                              <td className="tdh">
                                <button
                                  className="tdi"
                                  onClick={() =>
                                    handleViewClick({
                                      userId: ticket.user_id,
                                      ticketId: ticket.id,
                                      ticketNumber: ticket.ticketnumber,
                                      employeeName: ticket.name,
                                      clientEmail: ticket.email,
                                      ph: ticket.ph,
                                      title: ticket.e_title,
                                      errorDescription: ticket.e_des,
                                      file: ticket.files,
                                      status: ticket.status,
                                      asname: ticket.asname,
                                      closedby_name: ticket.clsname,
                                      create: ticket.create,
                                      res_time: ticket.res_time,
                                      closed_time: ticket.ctime,
                                      remarks: ticket?.remarks,
                                      approval1Time:
                                        ticket?.approved_by?.A1?.DateAndTime,
                                      approval2Time:
                                        ticket?.approved_by?.A2?.DateAndTime,
                                      a1name:
                                        ticket?.approved_by?.A1?.actionbyid ||
                                        "",
                                      a2name:
                                        ticket?.approved_by?.A2?.actionbyid ||
                                        "",
                                      a1status:
                                        ticket?.approved_by?.A1?.status || "",
                                      a2status:
                                        ticket?.approved_by?.A2?.status || "",
                                      unassignedTime: ticket?.unassignedTime,
                                    })
                                  }
                                >
                                  View
                                </button>
                              </td>

                              <td className="tdh">{ticket.status}</td>

                              {["admin", "imanager", "icoordinator"].includes(
                                userDetails?.role
                              ) && (
                                <td className="tdh">
                                  <button
                                    className="tdh-1"
                                    onClick={() => handlereopen(ticket.id)}
                                  >
                                    REOPEN
                                  </button>
                                </td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="tdh">
                              No tickets available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {totalPagesClosed > 1 && (
                  <div className="tdj">
                    <div>
                      <h2 className="tdk">
                        Page {currentPageClosed} of {totalPagesClosed}
                      </h2>

                      <div className="tdl">
                        {currentPageClosed !== 1 && (
                          <>
                            <button
                              className="tdm"
                              onClick={() => setCurrentPageClosed(1)}
                            >
                              &laquo; First page
                            </button>

                            <button
                              className="tdm"
                              onClick={() =>
                                setCurrentPageClosed((prev) =>
                                  Math.max(prev - 1, 1)
                                )
                              }
                            >
                              &lt; Previous
                            </button>
                          </>
                        )}

                        {currentPageClosed !== totalPagesClosed && (
                          <>
                            <button
                              className="tdn"
                              onClick={() =>
                                setCurrentPageClosed((prev) =>
                                  Math.min(prev + 1, totalPagesClosed)
                                )
                              }
                            >
                              Next &gt;
                            </button>

                            <button
                              className="tdo"
                              onClick={() =>
                                setCurrentPageClosed(totalPagesClosed)
                              }
                            >
                              Last page &raquo;
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {isModalOpen && selectedRow && (
                  <div className="tdp">
                    <div className="tdr">
                      <div className="tds-container">
                        <div className="tds" ref={boxRef2}>
                          <h2 className="tdt">Ticket Details</h2>

                          <div className="tinfo-container">
                            {/* Ticket Number with Info Tooltip */}
                            <div className="tinfo-ticket-wrapper">
                              <p className="tinfo-ticket-number">
                                <strong>{selectedRow.ticketNumber}</strong>
                                <span className="tinfo-icon-wrapper">
                                  <FaInfoCircle className="tinfo-icon" />
                                  <span className="tinfo-tooltip">
                                    Ticket Created: {selectedRow.create} <br />
                                    Ticket Opened:{" "}
                                    {selectedRow.res_time ===
                                      "0000-00-00 00:00:00" ||
                                    !selectedRow.res_time
                                      ? "-"
                                      : selectedRow.res_time}
                                    <br />
                                    {selectedRow.approval1Time && (
                                      <>
                                        Manager Approved Time:{" "}
                                        {selectedRow.a1name} -{" "}
                                        {selectedRow.approval1Time}
                                        <br />
                                      </>
                                    )}
                                    {selectedRow.approval2Time && (
                                      <>
                                        Business Head Approved Time:{" "}
                                        {selectedRow.a2name} -{" "}
                                        {selectedRow.approval2Time}
                                        <br />
                                      </>
                                    )}
                                    {selectedRow.unassignedTime && (
                                      <>
                                        Ticket Landed Time:{" "}
                                        {selectedRow.unassignedTime}
                                        <br />
                                      </>
                                    )}
                                  </span>
                                </span>
                              </p>
                            </div>

                            {/* Employee Info Row */}
                            <div className="tinfo-employee-row">
                              <p className="tinfo-field">
                                <strong className="tinfo-label">
                                  Employee Name:
                                </strong>
                                <br />
                                {selectedRow.employeeName}
                              </p>

                              <p className="tinfo-field">
                                <strong className="tinfo-label">
                                  Employee Email:
                                </strong>
                                <br />
                                {selectedRow.clientEmail}
                              </p>

                              <p className="tinfo-field">
                                <strong className="tinfo-label">
                                  Contact Number:
                                </strong>
                                <br />
                                {selectedRow.ph}
                              </p>
                            </div>

                            {/* Error Information */}
                            <div className="tinfo-employee-row">
                              <p className="tinfo-field">
                                <strong className="tinfo-label">
                                  Error Title:
                                </strong>
                                <br />
                                {selectedRow.title}
                              </p>
                              {selectedRow.remarks &&
                                typeof selectedRow.remarks === "object" &&
                                Object.entries(selectedRow.remarks).map(
                                  ([key, value]) => {
                                    let label =
                                      key === "A1" ? (
                                        <>
                                          Manager Remarks ({selectedRow?.a1name}
                                          ) - {selectedRow?.a1status}
                                        </>
                                      ) : key === "A2" ? (
                                        <>
                                          Business Head Remarks (
                                          {selectedRow?.a2name}) -{" "}
                                          {selectedRow?.a2status}
                                        </>
                                      ) : (
                                        key
                                      );
                                    return (
                                      <p key={key} className="tinfo-field">
                                        <strong className="tinfo-label">
                                          {label}:
                                        </strong>{" "}
                                        {value}
                                      </p>
                                    );
                                  }
                                )}
                            </div>
                            <p className="tinfo-field">
                              <strong className="tinfo-label">
                                Error Description:
                              </strong>
                              <br />
                              {selectedRow.errorDescription}
                            </p>

                            {/* File Link */}
                            {selectedRow.file && (
                              <p className="tinfo-field">
                                <strong className="tinfo-label">File:</strong>
                                <br />
                                <a
                                  href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="tinfo-file-link"
                                >
                                  {selectedRow.file}
                                </a>
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="chatbox-wrapper">
                          {selectedRow?.ticketId && (
                            <Chatbox
                              selectedRowID={selectedRow.ticketId}
                              selectedEmail={selectedRow.clientEmail}
                              status={selectedRow.status}
                              ticketclosed={selectedRow.closed_time}
                              ticketclosedbyname={selectedRow.closedby_name}
                              userId={selectedRow.userId}
                            />
                          )}

                          <button
                            className="ticket-details-btn"
                            onClick={() => scrollToBox(boxRef2)}
                          >
                            Ticket Details
                          </button>
                        </div>
                      </div>

                      <div className="tdq" onClick={closeModal}>
                        &times;
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          </div>
        </>
      )}
    </div>
  );
}

export default Ticketdashboard;
